import { LitElement, html } from '@hh/global.js'

class CollectionProductGrid extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.restoreScrollItem()
    this.setBreadcrumbData()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  restoreScrollItem() {
    const anchorId = location.hash
    if (!anchorId) return

    const productCardEl = document.querySelector(anchorId)
    if (!productCardEl) return

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'

      document.addEventListener('beforeunload', () => {
        history.scrollRestoration = 'auto'
      })
    }

    setTimeout(() => {
      productCardEl.scrollIntoView({
        behavior: 'smooth',
      })
    }, 250)
  }

  setBreadcrumbData() {
    const collectionUrl = this.dataset.collectionUrl
    const collectionTitle = this.dataset.collectionTitle

    if (collectionUrl && collectionTitle) {
      const breadcrumbData = {
        url: collectionUrl,
        title: collectionTitle,
      }
      sessionStorage.setItem('BREADCRUMB-PLP', JSON.stringify(breadcrumbData))
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-product-grid', CollectionProductGrid)
